__turbopack_context__.v({
  "arrow": "Carousel-module__2G1eFa__arrow",
  "arrowNext": "Carousel-module__2G1eFa__arrowNext",
  "arrowPrev": "Carousel-module__2G1eFa__arrowPrev",
  "arrowSquare": "Carousel-module__2G1eFa__arrowSquare",
  "arrows": "Carousel-module__2G1eFa__arrows",
  "arrowsSquare": "Carousel-module__2G1eFa__arrowsSquare",
  "chevron": "Carousel-module__2G1eFa__chevron",
  "dot": "Carousel-module__2G1eFa__dot",
  "dots": "Carousel-module__2G1eFa__dots",
  "dotsNumber": "Carousel-module__2G1eFa__dotsNumber",
  "root": "Carousel-module__2G1eFa__root",
  "slide": "Carousel-module__2G1eFa__slide",
  "track": "Carousel-module__2G1eFa__track",
  "viewport": "Carousel-module__2G1eFa__viewport",
});
